import React from 'react';
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"
import style from "./summary.module.css"

function AppStoreButton(props) {
    const data = useStaticQuery(graphql`
        query {
            appstoreicon: file(relativePath: { eq: "appstoreicon.png" }) {
                childImageSharp {
                    fluid(maxWidth: 200) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
        }
    `)

    return (
        <a className={style.appstorebutton} href="https://apps.apple.com/us/app/itemio/id1472869127">
            <Img fluid={data.appstoreicon.childImageSharp.fluid} />
        </a>
    );
}

export default AppStoreButton;